export const iconFontAwesomeMapsTrafficLight = (
	<i className="fa-solid fa-traffic-light"></i>
);
